module.exports = __webpack_public_path__ + "img/002.063b362e.png";